import { memo, ReactNode, useContext } from "react";
import { Helmet } from "react-helmet";
import { AppConfigContext } from "./AppConfigContext";
import { AccessDeniedStrategy, AuthorizationChecker } from "./Authorization";

export type PageProps = {
  children: ReactNode,
  requiredPermissions?: string | string[],
  requiredOneOfPermissions?: string | string[],
  title?: string
}

export const Page = memo<PageProps>((
  {
    children,
    requiredOneOfPermissions,
    requiredPermissions,
    title,
  }) => {
  const { pageTitlePrefix } = useContext(AppConfigContext);

  return (
    <>
      {
        !!title &&
        <Helmet>
          <title>{pageTitlePrefix}{title}</title>
        </Helmet>
      }
      <AuthorizationChecker
        requiredPermissions={requiredPermissions}
        requiredOneOfPermissions={requiredOneOfPermissions}
        strategy={AccessDeniedStrategy.renderStub}
      >
        {children}
      </AuthorizationChecker>
    </>
  );
});